import {moment, Base64} from 'helpers';
import {format} from './convert';

export function journal(diary) {
  return {
    date: diary.date ? moment(diary.date, format).unix() : undefined,
    goalId: diary.goalId,
    id: diary.serverId,
    subject: Base64.decode(diary.subject),
    tagIds: diary.tagIds,
    text: Base64.decode(diary.body),
    time: diary.time,
    taskId: diary.taskId,
  }
}
